import {
  MeasureOneExperienceType as MeasureOneExperienceTypeProto,
  MeasureOneSourceDataType as MeasureOneSourceDataTypeProto,
} from '@taxfyle/api-internal/internal/measure_one_pb'

export enum MeasureOneExperience {
  Employment = 'Employment',
  BankBrokerage = 'BankBrokerage',
}

export enum WellKnownDocumentTypeShortId {
  F1098 = '1098',
  F1099B = '1099_B',
  F1099Consolidated = '1099_COMPOSITE',
  F1099Div = '1099_DIV',
  F1099Int = '1099_INT',
  F1099Misc = '1099_MISC',
  F1099Nec = '1099_NEC',
  F1099Oid = '1099_OID',
  FW2 = 'W2',
}

export const MEASURE_ONE_SUPPORTED_DOCUMENT_TYPES = new Set<string>(
  Object.values(WellKnownDocumentTypeShortId),
)

export function mapMeasureOneExperienceToProtos(
  experience: MeasureOneExperience,
) {
  switch (experience) {
    case MeasureOneExperience.BankBrokerage:
      return MeasureOneExperienceTypeProto.MEASURE_ONE_EXPERIENCE_TYPE_BANK_BROKERAGE
    case MeasureOneExperience.Employment:
      return MeasureOneExperienceTypeProto.MEASURE_ONE_EXPERIENCE_TYPE_EMPLOYMENT
    default:
      return MeasureOneExperienceTypeProto.MEASURE_ONE_EXPERIENCE_TYPE_UNSPECIFIED
  }
}

export function mapMeasureOneSourceDataToProtos(
  documentTypeShortId: WellKnownDocumentTypeShortId,
) {
  switch (documentTypeShortId) {
    case WellKnownDocumentTypeShortId.F1099B:
      return MeasureOneSourceDataTypeProto.MEASURE_ONE_SOURCE_DATA_TYPE_FORM_1099_B
    case WellKnownDocumentTypeShortId.F1099Consolidated:
      return MeasureOneSourceDataTypeProto.MEASURE_ONE_SOURCE_DATA_TYPE_FORM_1099_CONSOLIDATED
    case WellKnownDocumentTypeShortId.F1099Div:
      return MeasureOneSourceDataTypeProto.MEASURE_ONE_SOURCE_DATA_TYPE_FORM_1099_DIV
    case WellKnownDocumentTypeShortId.F1099Int:
      return MeasureOneSourceDataTypeProto.MEASURE_ONE_SOURCE_DATA_TYPE_FORM_1099_INT
    case WellKnownDocumentTypeShortId.FW2:
      return MeasureOneSourceDataTypeProto.MEASURE_ONE_SOURCE_DATA_TYPE_FORM_W2
    case WellKnownDocumentTypeShortId.F1098:
      return MeasureOneSourceDataTypeProto.MEASURE_ONE_SOURCE_DATA_TYPE_FORM_1098
    case WellKnownDocumentTypeShortId.F1099Nec:
      return MeasureOneSourceDataTypeProto.MEASURE_ONE_SOURCE_DATA_TYPE_FORM_1099_NEC
    case WellKnownDocumentTypeShortId.F1099Oid:
      return MeasureOneSourceDataTypeProto.MEASURE_ONE_SOURCE_DATA_TYPE_FORM_1099_OID
    case WellKnownDocumentTypeShortId.F1099Misc:
      return MeasureOneSourceDataTypeProto.MEASURE_ONE_SOURCE_DATA_TYPE_FORM_1099_MISC
    default:
      return MeasureOneSourceDataTypeProto.MEASURE_ONE_SOURCE_DATA_TYPE_UNSPECIFIED
  }
}
